import { render, staticRenderFns } from "./VirtualScrollList.vue?vue&type=template&id=0ffe54cc"
import script from "./VirtualScrollList.vue?vue&type=script&lang=js"
export * from "./VirtualScrollList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports